<template>
  <v-container>
      <div class="paymentList">
        <Navbar />
        <v-data-table :headers="headers" :items="todos" v-if="dias < 90" :search="search" sort-by="tramites" disable-sort
        class="elevation-1" cols="12" xs="12" md="4" lg="4">
          <template v-slot:top>
            <v-toolbar dark color="#00b2bb">
              <v-row>
                <v-col>
                  <v-toolbar-title class="font-weight-thin">Mis Pagos</v-toolbar-title>
                  <v-divider class="mx-4" inset vertical></v-divider>
                  <v-spacer></v-spacer>
                  <v-dialog v-model="dialog" max-width="500px">
                    <v-card>
                      <v-card-title>
                        <span class="headline">{{ formTitle }}</span>
                      </v-card-title>

                      <v-card-text>
                        <v-container>
                          <v-row class="ma-5 justify-center">
                            <v-col>
                              <v-text-field v-model="editedItem.title" label="Title"></v-text-field>
                            </v-col>
                            <v-col>
                              <v-text-field v-model="editedItem.tramite" label="Tramite"></v-text-field>
                            </v-col>
                            <v-col>
                              <v-text-field v-model="editedItem.total" label="Total"></v-text-field>
                            </v-col>
                            <v-col>
                              <v-text-field v-model="editedItem.fecha" label="Fecha"></v-text-field>
                            </v-col>
                          </v-row>
                        </v-container>
                      </v-card-text>

                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
                        <v-btn color="blue darken-1" text @click="save">Save</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </v-col>
                <v-col>
                  <v-text-field
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="Buscar"
                    single-line
                    hide-details
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-toolbar>
          </template>
          <template v-slot:item.actions="{ item }">
            <!-- <v-icon small class="mr-2" @click="editItem(item)"></v-icon> -->
             <!-- <v-badge :value="hover" content="Ver" color="#00b2bb" left transition="slide-x-transition">
              <v-hover v-model="hover">
                <v-icon small class="ml-2" color="#00b2bb" @click="goToPage(item)">mdi-magnify</v-icon>
              </v-hover>
            </v-badge> -->
            <v-tooltip left>
              <template v-slot:activator="{ on }">
                <v-icon small class="ml-2" color="#00b2bb" v-on="on" @click="goToPage(item)">mdi-magnify</v-icon>
                <!-- <v-btn color="#00b2bb" dark v-on="on">Left</v-btn> -->
              </template>
              <span>Ver</span>
            </v-tooltip>
            <!-- <v-icon small class="mr-2" @click="editItem(item)">mdi-pencil</v-icon>
            <v-icon small @click="deleteItem(item)">mdi-delete</v-icon>  mdi-cloud-download-->
          </template>
        </v-data-table>
      </div>
  </v-container>
</template>

<script>
/* import api from '@/plugins/api' */
import endDocument from '@/mock/endDocument.json'
import axios from 'axios'
import Navbar from '@/components/Navbar'

export default {
  components: { Navbar },
  data: () => ({
    dialog: false,
    hover: false,
    hoverDownload: false,
    dias: 88,
    url: 'https://78.media.tumblr.com/tumblr_m39nv7PcCU1r326q7o1_500.png',
    search: '',
    headers: [
      { text: 'Tramite', value: 'name' },
      { text: 'Total', value: 'total' },
      { text: 'Fecha', value: 'date' },
      { text: '', value: 'actions', sortable: false }
    ],
    todos: [],
    editedIndex: -1,
    editedItem: {
      name: '',
      calories: 0,
      fat: 0,
      carbs: 0,
      protein: 0
    },
    defaultItem: {
      name: '',
      calories: 0,
      fat: 0,
      carbs: 0,
      protein: 0
    }
  }),

  computed: {
    formTitle () {
      return this.editedIndex === -1 ? 'New Item' : 'Edit Item'
    }
  },

  watch: {
    dialog (val) {
      val || this.close()
    }
  },

  created () {
    this.initialize()
  },

  methods: {
    async getTodos () {
      try {
        /* const response = await api.get('posts')
        this.todos = response.data
        console.log(response) */
        this.todos = endDocument
        console.log(endDocument)
      } catch (error) {
        alert('Get error ' + error)
        console.log('Get error ' + error)
      }
    },
    goToPage (item) {
      this.$router.push(`/Boleta/${item._id}`)
    },
    initialize () {
      this.getTodos()
    },

    editItem (item) {
      this.editedIndex = this.todos.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },

    deleteItem (item) {
      const index = this.todos.indexOf(item)
      confirm('Are you sure you want to delete this item?') &&
        this.todos.splice(index, 1)
    },

    close () {
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },

    save () {
      if (this.editedIndex > -1) {
        Object.assign(this.todos[this.editedIndex], this.editedItem)
      } else {
        this.todos.push(this.editedItem)
      }
      this.close()
    },
    forceFileDownload (response) {
      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      link.href = url
      console.log('aca ' + link.href)
      link.setAttribute('download', 'file.png') // or any other extension
      document.body.appendChild(link)
      link.click()
    },
    downloadFile () {
      axios({
        method: 'get',
        url: this.url,
        responseType: 'arraybuffer'
      })
        .then(response => {
          this.forceFileDownload(response)
        })
        .catch(() => console.log('Error al descargar archivo'))
    }
  }
}
</script>
